module.exports = {"name":"Tickets","identifier":"tickets","rights":[{"name":"ticket.bulk","identifier":"ticket.bulk"},{"name":"ticket.delete","identifier":"ticket.delete"},{"name":"ticket.download","identifier":"ticket.download"},{"name":"ticket.edit","identifier":"ticket.edit"},{"name":"ticket.list","identifier":"ticket.list"},{"name":"ticket.view","identifier":"ticket.view"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/users/data/modules/tickets.json
// module id = 2424
// module chunks = 1